export default __webpack_public_path__ + "static/char-s-29-zh-Hans-54f25bf546e27e189da0c52211f2f638.png";